export interface AboutUsInterface {
  title: string;
  document: string;
  pdf: {
    cookies: string;
    endUser: string;
    izjava: string;
    politika: string;
    saglasnost: string;
    uslovi: string;
  };
}

export const AboutUsDE: AboutUsInterface = {
  title: "Über uns",
  document: "Dokumente",
  pdf: {
    cookies: "Cookies",
    endUser: "Nutzungsbedingungen",
    izjava: "Datenschutzrichtlinie",
    politika: "Datenschutzrichtlinie",
    saglasnost: "Einverständnis zur Datenverarbeitung",
    uslovi: "Nutzungsbedingungen",
  },
};
